import { useCallback, useEffect, useState } from "react";
import api, { extractError } from "@/lib/api";

/** GET data hook with initial-load `loading`, background `refreshing`, error and refetch. */
export function useApiData(path, { immediate = true } = {}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(immediate);
  const [refreshing, setRefreshing] = useState(false);
  const [error, setError] = useState("");

  const fetchData = useCallback(
    async (isInitial = false) => {
      if (isInitial) setLoading(true);
      else setRefreshing(true);
      setError("");
      let ok = false;
      try {
        const res = await api.get(path);
        setData(res.data);
        ok = true;
      } catch (e) {
        setError(extractError(e, "Unable to load data."));
      } finally {
        if (isInitial) setLoading(false);
        else setRefreshing(false);
      }
      return ok;
    },
    [path]
  );

  useEffect(() => {
    if (immediate) fetchData(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchData]);

  const refetch = useCallback(() => fetchData(false), [fetchData]);

  return { data, loading, refreshing, error, refetch };
}
